import React from "react";

const SummaryButton = ({ type, label, active, onClick, disabled = false }) => (
  <button
    onClick={() => !disabled && onClick(type)}
    disabled={disabled}
    className={`px-3 py-2 font-bold text-sm rounded-md transition-colors
        ${
          disabled
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : active
              ? "bg-sky-800 text-white"
              : "bg-sky-800/10 text-sky-800 hover:bg-sky-800/20"
        }`}>
    {label}
  </button>
);

export default SummaryButton;
